import React, { useState, useCallback } from "react";
import CodeMirror from '@uiw/react-codemirror';
import { githubLight } from '@uiw/codemirror-theme-github';
import { loadLanguage } from '@uiw/codemirror-extensions-langs';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export default function TextareaCodeEditor(props) {
    const {
        height,
        defaultValue = '',
        placeholder = null,
        language = 'sass',
    } = props;

    const { t: gctrad } = useTranslation();
    const [value, setValue] = useState(defaultValue ?? '');

    const onChange = useCallback((val, viewUpdate) => {
        setValue(val);
    }, []);

    let required_attributes = {};
    if (props.required) {
        required_attributes['data-parsley-required'] = true;
    }

    return (
        <Wrapper>
            <CodeMirror
                value={value}
                theme={githubLight}
                height={height}
                placeholder={placeholder ?? `${gctrad('Ajoutez du code CSS ou SCSS')}...`}
                basicSetup={{ tabSize: 4 }}
                extensions={[loadLanguage(language)]}
                onChange={onChange}
            />

            <input
                type="hidden"
                name={props.name}
                defaultValue={value}
                {...required_attributes}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    .cm-editor {
        font-size: 0.85rem;
    }
    .ͼ1.cm-focused {
        outline-style: none;
    }
    ::-webkit-scrollbar {
        width: .4rem;
        height: .4rem;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #AAAAAA;
        border-radius: 50px;
    }
`;